<article
  class="lum-page lum-page--full-height lum-page__card  lum-c-sales-order-ag-table"
  [ngClass]="{
    'lum-page--hide-nav': activeTab === _ETab.LINE_ITEMS,
  }"
>
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading$ | async"
    [classes]="'loading blur'"
  ></div>

  <header class="lum-page-header">
    <h2 class="lum-page-header__heading w-max-content">Sales Orders</h2>
    <nav
      *ngIf="'red_DV-3306_order_line_items' | featureFlag"
      mat-tab-nav-bar
      [tabPanel]="salesOrderTabPanel"
      class="lum-page-header__tabs"
    >
      <a
        mat-tab-link
        (click)="activeTab = _ETab.ORDERS"
        [active]="activeTab === _ETab.ORDERS"
      >
        Orders
      </a>
      <a
        mat-tab-link
        (click)="activeTab = _ETab.LINE_ITEMS"
        [active]="activeTab === _ETab.LINE_ITEMS"
      >
        Line Items
      </a>
    </nav>
    <div class="lum-page-header__actions">
      <ng-container *ngIf="activeTab === _ETab.ORDERS">
        <button (click)="onRefetchTableData()" class="lum-button lum-button--link">
          <i class="fa fa-undo refresh-icon"></i>
          Refresh Table
        </button>
        <button
          *ngIf="!('utah_UTAH-161_new_filters' | featureFlag)"
          (click)="onToggleFilterSideBar()"
          class="lum-button lum-button--secondary"
        >
          <i class="fa fa-filter"></i>
          Filter
        </button>
        <button
          *ngIf="!('utah_UTAH-161_new_filters' | featureFlag)"
          (click)="onResetFilters()"
          class="lum-button lum-button--secondary"
        >
          <i class="fa fa-times"></i>
          Clear Filters
        </button>
        <lum-sales-order-bulk-action
          [currentQueryParams]="currentQueryParams"
          [pagination]="pagination"
          [ftPickAndPackEnabled]="ftPickAndPackEnabled"
          [ftEdiIntegrationEnabled]="ftEdiIntegrationEnabled"
          [inventoryPickAndPackEnabled]="inventoryPickAndPackEnabled"
          [canMarkAsShipped]="canMarkAsShipped"
          [channelsHasPushOrderMapping]="channelsHasPushOrderMapping"
          [isSelectAllRows]="isSelectAllRows"
          [selectedRows]="selectedRows"
          [totalRowCount]="totalRowCount"
          (updateSelectedRows)="handleUpdateSelectedRows($event)"
          (refreshTable)="onRefetchTableData()"
          (resetTable)="onResetTable()"
          (onSyncJobs)="onSyncJobs($event)"
          (previewPicklistItemsEvent)="onPreviewPicklistItems($event)"
          [selecatableRowData]="selecatableRowData"
          [remainingSelectableCount]="remainingSelectableCount"
          (onGroupByChangeEvent)="onGroupByChanged($event)"
          (onOmsFilterChangeEvent)="onAppIntegrationAccountChange($event)"
          (onClickCreateCustomFieldEvent)="createCustomField()"
        ></lum-sales-order-bulk-action>
      </ng-container>
      <ng-container *ngIf="activeTab === _ETab.LINE_ITEMS">
        <button
          [matMenuTriggerFor]="orderItemActionsMenu"
          type="button"
          class="lum-button lum-button--secondary"
        >
          Actions <i class="flaticon-more ml-2"></i>
        </button>
        <mat-menu #orderItemActionsMenu="matMenu" class="lum-mat-menu">
          <ng-container
            *ngFor="let action of orderItemActions; trackBy: trackByLabel"
          >
            <button
              *ngIf="
                action?.visible
                  ? action.visible(
                      gridApi?.getSelectedRows() || [],
                      detailGridApi?.getSelectedRows() || []
                    )
                  : true
              "
              mat-menu-item
              (click)="onActionClick(action)"
            >
              {{ action.label }}
            </button>
          </ng-container>
        </mat-menu>
      </ng-container>
    </div>
  </header>

  <div [hidden]="activeTab !== _ETab.ORDERS" class="d-contents">
    <div class="lum-page-nav">
      <ng-content [select]="sidemenu"></ng-content>
    </div>

    <div
      class="lum-page-content lum-page__ag-grid"
      [ngClass]="{ 'is-open-details': isSidebarOpen }"
    >
      <div class="lum-page__ag-grid__topbar">
        <lum-dumb-filters
          *ngIf="('utah_UTAH-161_new_filters' | featureFlag) && isFiltersOpen"
          [activeFilters]="activeFilters"
          (add)="handleFilterAdd()"
          (clear)="handleFiltersClear()"
          (remove)="handleFilterRemove($event)"
        ></lum-dumb-filters>
        <div class="d-flex align-items-center">
          <div *ngIf="'utah_UTAH-161_new_filters' | featureFlag" class="shrink">
            <button
              type="button"
              class="lum-button lum-button--small my-1"
              [ngClass]="{
                'lum-button--primary': isFiltersOpen,
                'lum-button--secondary': !isFiltersOpen,
              }"
              (click)="handleShowFiltersClick($event)"
            >
              <i class="fas fa-filter fa-sm"></i>
              Filters
            </button>
          </div>
          <div class="grow d-flex gap-x-4 justify-content-center">
            <span class="lum-label m-0 text-center">
              <ng-container *ngIf="isSelectAllRows; else whenNotAllSelected">
                Selected all <strong>{{ totalRowCount }}</strong>
                {{
                  totalRowCount
                    | number
                    | i18nSelect: { '1': 'order', 'other': 'orders' }
                }}
                in
                {{ currentQueryParams[fields.ORDER_STATUSES] | orderStatusLabel }}.
                <button
                  type="button"
                  class="linkish"
                  (click)="onNoteClearSelectionClick($event)"
                >
                  Clear selection.
                </button>
              </ng-container>
              <ng-template #whenNotAllSelected>
                <ng-container *ngIf="showLabelSelectAllRows; else noneSelected">
                  <strong>{{ selectedRows.length }}</strong>
                  {{
                    selectedRows.length
                      | number
                      | i18nSelect: { '1': 'order', 'other': 'orders' }
                  }}
                  selected.
                  <button
                    type="button"
                    class="linkish"
                    (click)="onNoteSelectAllClick($event)"
                  >
                    Select remaining {{ remainingSelectableCount }} orders in
                    {{
                      currentQueryParams[fields.ORDER_STATUSES] | orderStatusLabel
                    }}.
                  </button>
                </ng-container>
                <ng-template #noneSelected>No orders selected.</ng-template>
              </ng-template>
            </span>
          </div>
          <div class="d-flex gap-x-4 justify-content-end">
            <mat-checkbox
              [checked]="isSidebarOpen"
              [disabled]="isSelectAllRows"
              [matTooltip]="
                isSelectAllRows
                  ? 'The sidebar is not available when items outside of the' +
                    ' current page are selected.'
                  : null
              "
              [matTooltipShowDelay]="300"
              labelPosition="before"
              (change)="handleShowSidebarChange($event)"
            >
              <span class="lum-label d-inline">Show Sidebar</span>
            </mat-checkbox>
          </div>
        </div>
      </div>
      <ag-grid-angular
        class="
          ag-theme-alpine ag-theme-lum ag-theme-lum--next lum-page__ag-grid__table
        "
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [rowData]="rowData"
        [rowSelection]="'multiple'"
        [animateRows]="true"
        [gridOptions]="gridOptions"
        [suppressRowClickSelection]="true"
        (gridReady)="onGridReady($event)"
        (filterChanged)="onFilterChanged()"
        [isRowSelectable]="isRowSelectable"
        (rowSelected)="onRowSelected($event)"
        (selectionChanged)="onRowSelectionChanged()"
        (cellClicked)="onCellClicked($event)"
        (columnMoved)="onColumnMoved($event)"
        [getRowStyle]="getRowStyle"
      ></ag-grid-angular>

      <div class="lum-paging lum-page__ag-grid__paging">
        <div class="lum-paging__jump-to-page">
          <label class="lum-label my-2">Page</label>
          <input
            #pageInput
            class="lum-paging__jump-to-page-input"
            type="number"
            [value]="goToPageValue"
            (input)="handleGoToPageInput(pageInput)"
            (keyup.enter)="gotoPage(pageInput.value)"
            lumInvalidNumberInput
            lumFocusHighlight
          />
          <label class="lum-label my-2">of {{ pagination.last_page }}</label>
        </div>
        <mat-paginator
          [length]="pagination.total || 0"
          [pageSize]="pagination.per_page"
          [pageSizeOptions]="paginationConfig.pageSizeOptions"
          [pageIndex]="(pagination.current_page || 1) - 1"
          (page)="onPaginationEvent($event)"
          aria-label="Select page"
        ></mat-paginator>
      </div>

      <div *ngIf="isSidebarOpen" class="lum-page__ag-grid__details">
        <lum-sales-order-sidebar
          [singleSelectedRow]="singleSelectedRow"
          [consolidatedOrderItems]="consolidatedOrderItems"
          [selectedRows]="selectedRows"
          [isSelectAllRows]="isSelectAllRows"
          [warehouseAddress]="warehouseAddress"
          [hasShippingLabel]="hasShippingLabel"
          [childComponentConfigs]="childComponentConfigs"
          [pickingItems]="pickingItems"
          [appIntegrationAccountId]="selectedAppIntegrationAccount"
          (printShippingLabelEvent)="printShippingLabel()"
          (updateRecipientForm)="onUpdateRecipientForm($event)"
          (quickFulfillmentFlowEvent)="onInitQuickFulfillmentEvent($event)"
          (adjustmentEntryEvent)="onCreateAdjustmentEntry($event)"
          (bulkUpdateSuccessEvent)="onBulkUpdateSuccess($event)"
          [ftApplyPresets]="ftApplyPresets"
        ></lum-sales-order-sidebar>
      </div>
    </div>
  </div>

  <div [hidden]="activeTab !== _ETab.LINE_ITEMS" class="d-contents">
    <div class="lum-page-content lum-page__ag-grid">
      <lum-order-ag-table-order-line-items
        class="lum-page__ag-grid__table"
        [rowData]="lineItemRowData"
        [loading]="loadingLineItems$ | async"
        [orderType]="eOrderType.SALES_ORDER"
        (pageEvent)="onLineItemPaginationEvent($event)"
        (gridReady)="onLineItemGridReady($event)"
        (detailGridReady)="onLineItemDetailGridReady($event)"
      ></lum-order-ag-table-order-line-items>
    </div>
  </div>
</article>
